<template>
  <div role="group" class="btn-group btn-group-sm">
    <button v-for="projectCategory in projectCategories" :key="projectCategory.id"
      :class="categoryFilter[projectCategory.id] ? 'btn-success' : 'btn-info'"
      @click="toggleCategory(projectCategory.id)" class="btn">{{ projectCategory.name }}</button>
    <button @click="toggleCategory(null)" class="btn" :class="categoryFilter[null] ? 'btn-success' : 'btn-info'">No
      category</button>
    <button @click="toggleCategory('active')" class="btn"
      :class="categoryFilter['active'] ? 'btn-success' : 'btn-info'">Active</button>
  </div>
</template>

<script>
import Vue from 'vue';

import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'ProjectCategoryFilter',
  mounted() {
    this.setDefault();
  },
  components: {},
  data() {
    return {
      hasDefaultsSet: false,
    };
  },
  model: {
    prop: 'categoryFilter'
  },
  props: {
    categoryFilter: {},
    defaultCategories: {
      default() { return []; },
    }
  },
  computed: {
    ...mapGetters('JiraProjects', ['projectCategories']),
    ...mapGetters('Filters', ['filters'])
  },
  watch: {
    projectCategories() { this.setDefault(); },
  },
  methods: {
    toggleCategory(catId) {
      Vue.set(this.categoryFilter, catId, !this.categoryFilter[catId]);
      this.$emit('input', this.categoryFilter);
      if (['ProjectOverview'].includes(this.$store.state.Filters.routeName)) {
        Vue.set(this.$store.state.Filters.parameters.categories, catId, !this.categoryFilter[catId]);
      }
    },
    setDefault() {
      if (this.hasDefaultsSet || this.defaultCategories.length <= 0) {
        this.hasDefaultsSet = true;
        return;
      }
      if (this.hasDefaultsSet) return;
      const cats = Object.values(this.projectCategories);
      if (cats.length <= 0) return; // there are at least one category when loaded
      this.defaultCategories.forEach((c) => {
        const cat = cats.find((pc) => pc.name === c);
        if (cat) Vue.set(this.categoryFilter, cat.id, true);
      });
      this.$emit('input', this.categoryFilter);
      this.hasDefaultsSet = true;
    }
  },
};

</script>
<style scoped>
</style>
